import React from 'react';
import { history } from 'ice';
import NotFound from '@recept-pc-sdk/static/404.png';

import styles from './index.module.scss';

export default (props) => {
  return (
    <div className={styles.basicnotfound}>
      <div className={styles.exceptioncontent}>
        <img src={NotFound} className={styles.imgException} alt="页面出错啦" />
        <div className="prompt">
          <h3 className={styles.title}>{props.content || '页面出错啦，请稍后再试'}</h3>
          <p className={styles.description}>
            点击
            <span onClick={() => history.go(-1)} className={styles.back}>
              返回
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
